import React from "react"
import { Link } from "gatsby"
import Img from "gatsby-image"

export default function ListItem( data ) {
  return (
    <Link className="item-list" to={data.to}>
      <div className="item-list-title">{ data.title }</div>
      <div className="item-list-subtitle">{ data.subtitle }</div>
    </Link>
  )
}
